export default "__VITE_ASSET__BjYRLolw__"